
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.TaskTypePropertiesGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class TaskTypePropertiesGrid extends SiteEntityGrid<TaskTypePropertiesRow, any>
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.TaskTypeProperties'; }
        protected getDialogType() { return TaskTypePropertiesDialog; }
        protected getIdProperty() { return TaskTypePropertiesRow.idProperty; }
        protected getLocalTextPrefix() { return TaskTypePropertiesRow.localTextPrefix; }
        protected getService() { return TaskTypePropertiesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._taskTypeCode);
        }

        private _taskTypeCode: string;

        public set taskTypeCode(value: string) {
            if (this._taskTypeCode !== value) {
                this._taskTypeCode = value;
                this.setEquality(TaskTypePropertiesRow.Fields.TaskTypeCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<TaskTypePropertiesRow>{
                TaskTypeCode: this._taskTypeCode
            });
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._taskTypeCode;
        }

    }
}